module.exports = __webpack_public_path__ + "static/media/destination_image_3.5f0d3bda.webp";